import { render } from "./BoqLineItemTable.vue?vue&type=template&id=6548d474&scoped=true"
import script from "./BoqLineItemTable.vue?vue&type=script&lang=js"
export * from "./BoqLineItemTable.vue?vue&type=script&lang=js"

import "./BoqLineItemTable.vue?vue&type=style&index=0&id=6548d474&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6548d474"]])

export default __exports__